const profileEditRequests = {
  pageTitle: "Profile Edit Requests",
  listBreadcrumb: "Profile Edit Requests",
  searchPlaceholder: "Search by company name",
  statusFilterLabel: "Status",
  // The internal pending / in-review states are shown as "New" (nobody has
  // opened the request yet) and "Opened".
  statusOptions: {
    pending: "New",
    in_review: "Opened",
    approved: "Accepted",
    rejected: "Rejected",
  },
  columns: {
    company: "Company",
    requestedBy: "Requested by",
    requestDate: "Request date",
    requestStatus: "Request status",
    editedFields: "Edited fields",
  },
  showingRange: "Showing {from}–{to} of {total} requests",
  emptyTitle: "No profile edit requests",
  emptyDescription: "Requests from companies will appear here.",
};

export default profileEditRequests;
